import { render, staticRenderFns } from "./DeleteStar.vue?vue&type=template&id=32bc50bb"
import script from "./DeleteStar.vue?vue&type=script&lang=js"
export * from "./DeleteStar.vue?vue&type=script&lang=js"
import style0 from "./DeleteStar.vue?vue&type=style&index=0&id=32bc50bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports